<template>
  <div>
  <b-table class="mt-3 table-stats" :items="workerStatsTable" :fields="this.getFields" :busy="loading" show-empty empty-text="Смен работника за выбранный период не найдено" striped foot-clone>
    <template slot="[date]" slot-scope="data">
      {{$moment(data.value).format('DD.MM.YYYY')}}
    </template>
    <template slot="[timeOpened]" slot-scope="data">
      {{$moment(data.value).format('HH:mm DD.MM.YYYY')}}
    </template>
    <template slot="[timeClosed]" slot-scope="data">
      {{data.value ? $moment(data.value).format('HH:mm DD.MM.YYYY') : '-'}}
    </template>
    <template slot="[restPoint]" slot-scope="data">
      {{data.value}}
    </template>
    <template slot="[hour]" slot-scope="data">
      {{data.value}}
    </template>
    <template slot="[hoursOnWork]" slot-scope="data">
      {{formatHours(data.value)}}
    </template>
    <template slot="[totalWorkersHoursByPointDay]" slot-scope="data">
      {{data.value}}
    </template>
    <template slot="[]" slot-scope="data">
      {{data.value.toFixed(2)}}
    </template>
    <template slot="FOOT[date]" slot-scope="data">
      Итого:
    </template>
    <template slot="FOOT[hoursOnWork]" slot-scope="data">
      {{formatHours(workerStatsSummary.hoursOnWork)}}
    </template>
    <template slot="FOOT[sumFromHours]" slot-scope="data">
      {{workerStatsSummary.sumFromHours.toFixed(2)}}
    </template>
    <template slot="FOOT[sumPercentageOfTurnover]" slot-scope="data">
      {{workerStatsSummary.sumPercentageOfTurnover.toFixed(2)}}
    </template>
    <template slot="FOOT[total]" slot-scope="data">
      {{workerStatsSummary.total.toFixed(2)}}
    </template>
  </b-table>
  </div>
</template>

<script>
import formatHours from '../helpers/formatHours'
export default {
  name: 'MotivateCookerTableStats',
  props: {
    namespace: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean
    }
  },
  data () {
    return {
      items: [
      ]
    }
  },
  created () {
  },
  computed: {
    workerStatsTable () {
      return this.$store.getters[`${this.namespace}/workerStatsTable`]
    },
    workerStatsSummary () {
      return this.$store.getters[`${this.namespace}/workerStatsSummary`]
    },
    groupByDay () {
      return this.$store.getters[`${this.namespace}/groupByDay`]
    },
    getFields () {
      let fieldsArr = [
        {
          key: 'date',
          label: 'Дата'
        },
        {
          key: 'hour',
          label: 'Час'
        },
        {
          key: 'restPoint',
          label: 'Точка'
        },
        {
          key: 'timeOpened',
          label: 'Смена открыта'
        },
        {
          key: 'timeClosed',
          label: 'Смена закрыта'
        },
        {
          key: 'hoursOnWork',
          label: 'Часов проработано'
        },
        {
          key: 'sumFromHours',
          label: 'Сумма за часы'
        },
        {
          key: 'percentTarget',
          label: 'Процент заказов в целевое время'
        },
        {
          key: 'percentReward',
          label: 'Награда в процентах'
        },
        {
          key: 'sumPercentageOfTurnover',
          label: 'Сумма с оборота'
        },
        {
          key: 'turnover',
          label: 'Оборот'
        },
        {
          key: 'total',
          label: 'Итого'
        },
        {
          key: 'totalWorkersHoursByPointDay',
          label: 'Сотрудников на смене'
        }
      ]
      fieldsArr.forEach((item, index) => {
        if (this.groupByDay && (item.key === 'hour' || item.key === 'percentTarget')) {
          fieldsArr.splice(index, 1)
        }
      })
      return fieldsArr
    }
  },
  methods: {
    formatHours(value) {
      return formatHours(value);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MotivateCookerTableStats.vue